import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=97d8a456&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97d8a456')) {
      api.createRecord('97d8a456', component.options)
    } else {
      api.reload('97d8a456', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=97d8a456&", function () {
      api.rerender('97d8a456', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4v7EtJXvl4QHn/JS/imageCarousel.vue"
export default component.exports